<script setup>
import { computed } from 'vue';

const props = defineProps({
    media: {
        type: Object,
        required: true,
    },
    width: {
        type: Number,
    },
    height: {
        type: Number,
    },
    thumbnail: {
        type: Boolean,
        default: false
    },
});

const isVideo = computed(() => {
    return props.media.mediaContentType === 'VIDEO';
});

const isImage = computed(() => {
    return props.media.mediaContentType === 'IMAGE';
});
</script>

<template>
    <img
        v-if="thumbnail"
        class="preview-image"
        :src="media.previewImage.url"
        :alt="media.previewImage.altText"
        :width="width"
        :height="height" />
    <div v-else :class="{'product-media': true, 'media-image': isImage, 'media-video': isVideo}">
        <img
            v-if="isImage"
            class="preview-image"
            :src="media.previewImage.url"
            :alt="media.previewImage.altText"
            :width="width"
            :height="height"
            @click="showFullSize = true" />

        <div v-if="isVideo" class="video">
            <video controls class="video-player" :poster="media.previewImage.url">
                <source v-for="source in media.sources" :key="source" :src="source.url" :type="source.mimeType">
                Your browser does not support the video tag.
            </video>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.full-size-media {
    position: fixed;
    top: 0;
    left: 0;
    background-color: red;
    width: 100%;
    height: 100dvh;
    z-index: 100;

    .close-fullsize {
        position: absolute;
        top: 1rem;
        right: 1rem;
        background-color: white;
        border: none;
        font-size: 1.5rem;
        cursor: pointer;
    }
}

.product-media {
    max-height: 400px;
    height: 100%;
}

.preview-image {
    background-color: white;
    width: 100%;
    height: 100%;
    max-height: 400px;
    object-fit: contain;
}

.fullsize-image {
    width: 100%;
    height: auto;
    max-height: 100dvh;
    object-fit: contain;
}

.video {
    display: flex;
    align-self: center;
}

.video-player {
    width: 100%;
    height: auto;
}
</style>